<template>
  <svg :width="size" :height="size * 4/3" viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2 14.5C1.725 14.5 1.5 14.275 1.5 14V2C1.5 1.725 1.725 1.5 2 1.5H7V4C7 4.55312 7.44688 5 8 5H10.5V14C10.5 14.275 10.275 14.5 10 14.5H2ZM2 0C0.896875 0 0 0.896875 0 2V14C0 15.1031 0.896875 16 2 16H10C11.1031 16 12 15.1031 12 14V4.82812C12 4.29688 11.7906 3.7875 11.4156 3.4125L8.58438 0.584375C8.20938 0.209375 7.70312 0 7.17188 0H2ZM5 8C5 7.73478 4.89464 7.48043 4.70711 7.29289C4.51957 7.10536 4.26522 7 4 7C3.73478 7 3.48043 7.10536 3.29289 7.29289C3.10536 7.48043 3 7.73478 3 8C3 8.26522 3.10536 8.51957 3.29289 8.70711C3.48043 8.89464 3.73478 9 4 9C4.26522 9 4.51957 8.89464 4.70711 8.70711C4.89464 8.51957 5 8.26522 5 8ZM7.1625 9.46562C7.06875 9.33125 6.91563 9.25 6.75 9.25C6.58437 9.25 6.43125 9.33125 6.3375 9.46562L5.04688 11.3313L4.675 10.7344C4.58438 10.5875 4.42188 10.5 4.25 10.5C4.07812 10.5 3.91875 10.5875 3.825 10.7344L2.575 12.7344C2.47813 12.8875 2.475 13.0813 2.5625 13.2406C2.65 13.4 2.81875 13.4969 3 13.4969H4.5H5.5H6.75H9C9.1875 13.4969 9.35625 13.3937 9.44375 13.2281C9.53125 13.0625 9.51875 12.8656 9.4125 12.7125L7.1625 9.4625V9.46562Z"
      :fill="color" />
  </svg>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: '#242424',
    },
    size: {
      type: Number,
      default: 12,
    },
  },
};
</script>
